// i18n area 'tasks' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.hr-HR.meta.json.
import type { enUS } from './tasks'

export const hrHR: typeof enUS = {
  macrotasks: {
    title: 'Makrozadaci',
    subtitle: 'Složene operacije — nastavljive od neuspjelog koraka ili prekidive',
    colType: 'Tip',
    colTarget: 'Objekt',
    colPhase: 'Faza',
    colSteps: 'Koraci',
    empty: 'Nema makrozadataka',
    detail: 'Detalji',
    failedAt: 'neuspio na',
    resume: 'Pokušaj ponovno od neuspjelog koraka',
    abort: 'Prekini sve',
    cancel: 'Otkaži',
    actionError: 'Radnja je odbijena'
  },
  tasks: {
    title: 'Zadaci',
    searchPlaceholder: 'Pretraži po tipu ili targetu',
    type: 'Tip',
    target: 'Target',
    phaseLabel: 'Faza',
    progress: 'Napredak',
    started: 'Započet',
    finished: 'Završen',
    node: 'Čvor',
    empty: 'Nema zadataka',
    loadError: 'Zadatke nije moguće učitati — je li TVirt backend dostupan?',
    limboHint: "Čvor '{node}' nedostupan od {time} — zadatak drži write lease na svom targetu dok se čvor ne vrati ili dok ne bude potvrđeno da je isključen",
    nodeAttested: 'Čvor potvrđeno isključen',
    phase: {
      queued: 'U redu čekanja',
      running: 'U izvođenju',
      succeeded: 'Dovršen',
      failed: 'Neuspio',
      cancelled: 'Otkazan',
      'failed-at-step': 'Neuspio na koraku',
      aborted: 'Prekinut'
    },
    dropdown: {
      tooltip: 'Zadaci u tijeku',
      title: 'Zadaci u tijeku',
      empty: 'Nema zadataka u tijeku',
      viewAll: 'Prikaži sve zadatke'
    },
    detail: {
      open: 'Detalji',
      scope: 'Opseg',
      message: 'Poruka',
      params: 'Parametri',
      result: 'Rezultat',
      errorTitle: 'Pogreška',
      steps: 'Koraci',
      failedAt: 'neuspio na',
      superseded: 'zamijenjen',
      step: 'Korak',
      parent: 'Nadređeni zadatak',
      failedStep: 'Neuspjeli korak',
      log: 'Zapisnik',
      logEmpty: 'Još nema zapisa u zapisniku',
      close: 'Zatvori'
    },
    actions: {
      cancel: 'Otkaži',
      resume: 'Pokušaj ponovno od neuspjelog koraka',
      abort: 'Prekini sve (poništavanje dovršenih koraka)',
      refused: 'Radnja je odbijena'
    }
  },
  events: {
    loadError: 'Dnevnik se nije mogao učitati — je li TVirt backend dostupan?',
    title: 'Događaji',
    subtitle: 'Povijesno pamćenje klastera: svršene činjenice, od najnovijih',
    filterSeverity: 'Ozbiljnost',
    filterCategory: 'Kategorija',
    filterAll: 'Sve',
    searchLabel: 'Traži',
    searchPlaceholder: 'Pretraži cijeli dnevnik',
    subjectFilter: 'Događaji {subject} — prikaži sve',
    colAt: 'Kada',
    colSeverity: 'Ozbiljnost',
    colType: 'Tip',
    colSubject: 'Subjekt',
    colActor: 'Tko',
    colNode: 'Node',
    colMessage: 'Poruka',
    empty: 'Nema događaja',
    loadMore: 'Učitaj još',
    actorSystem: 'sustav',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID događaja',
    taskCollectedHint: 'Task ima kraću retenciju: nakon prikupljanja poveznica više ne odgovara',
    severity: {
      info: 'Informacija',
      warning: 'Upozorenje',
      error: 'Greška',
      critical: 'Kritično'
    },
    category: {
      lifecycle: 'Životni ciklus',
      config: 'Konfiguracija',
      availability: 'Dostupnost',
      security: 'Sigurnost'
    },
    type: {
      haNetsvcFailedOver: 'Failover mrežne usluge',
      haNetsvcNoCandidate: 'Mrežna usluga bez kandidatskog čvora',
      haNetsvcReaped: 'Lokalna instanca požnjevena pri povratku',
      netsvcFloatipMoved: 'Plutajući IP premješten na drugog držatelja',
      netsvcFloatipNoHolder: 'Plutajući IP bez zdravog cilja',
      haAppFailedOver: 'Failover App instance',
      haAppNoCandidate: 'App instanca bez kandidata čvora',
      haAppStorageLocalSkip: 'App instanca nije prebačena: trajni podaci lokalni na mrtvom čvoru',
      haAppReaped: 'Lokalni pod App instance požnjeven pri povratku'
    }
  },
  audit: {
    loadError: 'Audit registar se nije mogao učitati — je li TVirt backend dostupan?',
    title: 'Audit',
    subtitle: 'Tko je što učinio, kada i nad kojim objektom — pokušane radnje, uključujući odbijene',
    filterOutcome: 'Ishod',
    filterAll: 'Svi',
    filterSudo: 'Samo povišene radnje',
    colAt: 'Kada',
    colActor: 'Tko',
    colAction: 'Radnja',
    colTarget: 'Objekt',
    colOutcome: 'Ishod',
    colNode: 'Node',
    empty: 'Nema zabilježenih radnji',
    loadMore: 'Učitaj još',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Ruta',
    detailProblem: 'Razlog',
    detailTask: 'Task',
    detailClientIp: 'Odakle',
    detailId: 'ID zapisa',
    detailSession: 'Sesija',
    taskHint: 'Ishod prihvaćene radnje živi u dnevniku događaja, pod istim id-om taska',
    outcome: {
      succeeded: 'Uspjelo',
      accepted: 'Prihvaćeno',
      denied: 'Odbijeno',
      rejected: 'Odbačeno',
      failed: 'Neuspjelo'
    }
  },
  notifications: {
    loadError: 'Obavijesti se nisu mogle učitati — je li TVirt backend dostupan?',
    actionError: 'Radnja je odbijena',
    title: 'Obavijesti',
    subtitle: 'Odredišta prema kojima činjenice dnevnika napuštaju klaster',
    rulesTitle: 'Pravila',
    rulesSubtitle: 'Koje činjenice izlaze i kamo',
    deliveriesTitle: 'Isporuke',
    deliveriesSubtitle: 'Ishod svake obavijesti, s razlogom kada ne uspije',
    colName: 'Naziv',
    colKind: 'Vrsta',
    colWhere: 'Kamo',
    colScope: 'Scope',
    colSeverity: 'Ozbiljnost',
    colMatch: 'Filtar',
    colTargets: 'Odredište',
    colAt: 'Kada',
    colState: 'Stanje',
    colEvent: 'Događaj',
    colAttempts: 'Pokušaji',
    colOutcome: 'Ishod',
    empty: 'Nema redaka',
    matchAll: 'sve činjenice',
    test: 'Isprobaj',
    testOk: 'Probna obavijest isporučena na {target}',
    testFailed: 'Proba prema {target} nije uspjela: {reason}',
    retry: 'Vrati u red',
    retried: 'Isporuka vraćena u red',
    grouped: 'i još {count} ponavljanja',
    state: {
      failed: 'Neuspjela',
      pending: 'U redu čekanja',
      sending: 'Šalje se',
      sent: 'Poslana'
    },
    tabTargets: 'Odredišta',
    tabRules: 'Pravila',
    tabDeliveries: 'Dostave',
    targetCreateTitle: 'Novo odredište',
    ruleCreateTitle: 'Novo pravilo',
    nameHint: 'Mala slova, brojke i crtice; jedinstveno po opsegu',
    kindImmutableHint: 'Nepromjenjivo: promjena vrste znači stvaranje drugog odredišta',
    kindSmtp: 'Pošta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stanje',
    enabledOn: 'Aktivno',
    enabledOff: 'Zaustavljeno',
    smtpHost: 'SMTP poslužitelj',
    smtpPort: 'Port',
    smtpPortHint: 'Uobičajeno: 25 bez TLS-a, 587 sa starttls, 465 s tls',
    smtpSecurity: 'Sigurnost',
    smtpFrom: 'Pošiljatelj',
    smtpTo: 'Primatelji',
    smtpToHint: 'Jedna ili više adresa odvojenih zarezom',
    webhookUrl: 'URL',
    payload: 'Sadržaj',
    payloadHint: 'Uz minimal poruka i podaci događaja ne izlaze iz klastera',
    credential: 'Vjerodajnica',
    credentialNone: 'Nema',
    credentialHintSmtp: 'Račun releja iz spremišta ključeva; nema znači anonimni SMTP',
    credentialHintWebhook: 'Tajna za potpisivanje iz spremišta ključeva; bez potpisa svatko ko zna URL može se predstaviti kao klaster',
    minSeverityHint: 'Prag, ne skup: od ove težine i više',
    categories: 'Kategorije',
    categoriesHint: 'Prazno = sve',
    types: 'Vrste događaja',
    typesHint: 'Odvojene zarezom; prazno = sve. Nepoznata vrsta se odbija',
    targetsHint: 'Najmanje jedno; moraju biti u opsegu pravila ili u njegovom pretku',
    recursiveOn: 'I podređeni opsezi',
    recursiveOff: 'Samo ovaj opseg',
    recursiveHint: 'Resursi žive u listovima: bez djece pravilo na korijenu obavještava gotovo ništa',
    repeatWindow: 'Prozor grupiranja (s)',
    repeatWindowHint: 'Unutar prozora ponavljanja ne šalju poštu: broje se na prvom. 0 isključuje',
    targetInUseError: 'Odredište {name} još koristi jedno pravilo'
  }
}
